import Vue from 'vue'
import Router from 'vue-router'
import first from '@/components/first/first'
import myfooter from '@/components/commen/myfooter'
import compere from '@/components/compere/compere'
import liveStreaming from '@/components/liveStreaming/liveStreaming'
import programPage from '@/components/programPage/programPage'
import programStop from '@/components/programStop/programStop'
import programRecorded from '@/components/programRecorded/programRecorded'
import lifeLive from '@/components/lifeLive/lifeLive'
import user from '@/components/user/user'
//频率主页
import ratePage from '@/components/ratePage/ratePage'
import programcommen from '@/components/commen/programcommen'
import programcommen1 from '@/components/commen/programcommen1'
import lifeCommen from '@/components/commen/lifeCommen'
import downloadPage from '@/components/downloadPage/downloadPage'
import downloadPage2 from '@/components/downloadPage/downloadPage2'
import delPage from '@/components/downloadPage/delPage'
import seefmDownload from '@/components/downloadPage/seefmDownload'
import hotRecommendMiddle from '@/components/commen/hotRecommendMiddle'
import hotRecommendBold from '@/components/commen/hotRecommendBold'
import splitLight from '@/components/commen/spliteLight'
import spliteBold from '@/components/commen/spliteBold'
import toast from '@/components/commen/toast'
// import loading from '@/components/commen/loading'

//改版节目主页
import programRecordedNew from '@/components/programRecordedNew/programRecordedNew'
import compereNew from '@/components/compereNew/compereNew'
//标签页面
import tagPage from '@/components/tagPage/tagPage'
import playPage from '@/components/tagPage/playPage'
// 短视频页面
import shortVideo from '@/components/shortVideo/shortVideo'
import downloadApp from '@/components/downloadPage/downloadApp'
//语音房分享页面
import voiceRoom from '@/components/voiceRoom/voiceRoom'





Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'first',
      component:first
    }
    , {
      path: '/myfooter',
      name: 'myfooter',
      component: myfooter
    },
    {
      path: '/compere',
      name:'compere',
      component: compere,

      // children:[
      //   {
      //     path:"commenProgram", name:'commenProgram',component:commenProgram,
      //   },
      //   {
      //     path:"commenLife", name:'commenLife',component:commenLife,
      //   },
       
        
      // ],
      // redirect:"/compere/commenProgram"
    },{
      path: '/programPage',
      name: 'programPage',
      component: programPage
    },{
      path: '/liveStreaming',
      name: 'liveStreaming',
      component: liveStreaming
    },{
      path: '/programStop',
      name: 'programStop',
      component:programStop
    },{
      path: '/programRecorded',
      name: 'programRecorded',
      component: programRecorded
    },{
      path: '/ratePage',
      name: 'ratePage',
      component: ratePage
    },{
      path: '/tagPage',
      name: 'tagPage',
      component: tagPage
    },{
      path: '/playPage',
      name: 'playPage',
      component: playPage
    },{
      path: '/lifeLive',
      name: 'lifeLive',
      component: lifeLive
    },{
      path: '/programcommen',
      name: 'programcommen',
      component: programcommen
    },
    {
      path: '/programcommen1',
      name: 'programcommen1',
      component: programcommen1
    },
    {
      path: '/lifeCommen',
      name: 'lifeCommen',
      component: lifeCommen
    },
    
    {
      path: '/splitLight',
      name: 'splitLight',
      component: splitLight
    },{
      path: '/downloadPage',
      name: 'downloadPage',
      component: downloadPage
    },
    {
      path: '/downloadPage2',
      name: 'downloadPage2',
      component: downloadPage2
    },
    {
      path: '/delPage',
      name: 'delPage',
      component: delPage
    },
    {
      path: '/seefmDownload',
      name: 'seefmDownload',
      component: seefmDownload
    },{
      path: '/spliteBold',
      name: 'spliteBold',
      component: spliteBold
    },{
      path: '/hotRecommendMiddle',
      name: 'hotRecommendMiddle',
      component: hotRecommendMiddle
    },
    {
      path: '/hotRecommendBold',
      name: 'hotRecommendBold',
      component: hotRecommendBold
    },
    {
      path: '/toast',
      name: 'toast',
      component: toast
    },
    {
      path: '/programRecordedNew',
      name: 'programRecordedNew',
      component: programRecordedNew
    },
    {
      path: '/compereNew',
      name: 'compereNew',
      component: compereNew
    },
    {
      path: '/shortVideo',
      name: 'shortVideo',
      component: shortVideo
    },
    {
      path: '/downloadApp',
      name: 'downloadApp',
      component: downloadApp
    },
    {
      path: '/voiceRoom',
      name: 'voiceRoom',
      component: voiceRoom
    },
    {
      path: '/user',
      name: 'user',
      component: user
    },
    // {
    //   path: '/loading',
    //   name: 'loading',
    //   component: loading
    // },
   
  ]
},



)
